import React, { useEffect, useLayoutEffect } from "react";
import SuccessfulSubmit from "../../../components/cards/SuccessfulSubmit";
import { useDispatch, useSelector } from "react-redux";
import MainContainer from "../../../components/container/MainContainer";
import { CircleCheckBigIcon } from "lucide-react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getProject,
  unsetSelectedProject,
} from "../../../features/projectsSlice";
import Loading from "../../../components/loading/Loading";
import loadStatus from "../../../util/loadStatus";
import NetworkError from "../../error/NetworkError";

const ProposalSubmitState = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.user.userInfo);
  const project = useSelector((state) => state.projects.selected);
  const projectLoad = useSelector((state) => state.projects.load.getProject);

  useEffect(() => {
    dispatch(getProject(id));

    return () => {
      dispatch(unsetSelectedProject());
    };
  }, []);

  useLayoutEffect(() => {
    if (
      (id && project.id && project.stage.step_number < 8) ||
      (id && project.id && project.stage.step_number > 9)
    ) {
      return navigate("/projects/proposals");
    }
  }, [project, user]);

  if (projectLoad === loadStatus.loading) {
    return <Loading />;
  }

  if (projectLoad === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      {project.id && (
        <SuccessfulSubmit
          message={`The Proposal has been submitted to the ${user.province.name} PDO Department`}
          icon={CircleCheckBigIcon}
          link="/projects/proposals"
          linkName="Go to My Proposals"
        />
      )}
    </MainContainer>
  );
};

export default ProposalSubmitState;
